export * from './lib/bank-details/bank-details.component';
